import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getDay/index.js';

var require$$21 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$21 as default };
